import React, { Component } from "react";
import Faker from "faker";
export default class CaseCard extends Component {
  constructor(props) {
    super();
  }
  render() {
    return (
      <div
        className="case"
        onClick={() => {
          if (typeof this.props.onClick == "function") {
            this.props.onClick();
          }
        }}
      >
        <span className="casetitle">{this.props.title}</span>
        <div className="caselawyer">{this.props.name}</div>
        <div className="casetime">{this.props.time}</div>
        <div className="casestatus">{this.props.approved}</div>
        <a href="#/" className="gotolink">
          <i className="fa fa-external-link" />
        </a>
      </div>
    );
  }
}
